
import { gsap } from "gsap"
import {awdScroll, barba, isAllMobileDevices, isMobile, setCookie, winsize, riseAndFadeIn} from './bundle'
class InfiniteWall{
    constructor(container){
        this.container = container
        this.products = this.container.querySelectorAll('.product')
        this.wholeWidth = 0
        this.wholeHeight = 0
        this.isDown = false
        this.power = 2
        this.easing = 0.1
        this.speed = 0.5
        this.timeout = null
        this.wallDisabled = true
        this.sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        }
        this.horizontal = {
            start: 0,
            distance: 0,
            target: 0,
            current: 0,
            velocity: 0,
            direction: null,
            reset: 0,
            offset: 0,
            mobileShift: 0
        }
        this.vertical = {
            start: 0,
            distance: 0,
            target: 0,
            current: 0,
            velocity: 0,
            direction: null,
            reset: 0
        }
        
        if(isAllMobileDevices){
            this.horizontal.offset = this.sizes.width
            // this.horizontal.mobileShift = this.sizes.width/2
        }

        
        // this.customCursor = document.getElementById('customCursor')
        // this.customCursorContainer = this.customCursor.querySelector('.customCursor__container')
        // this.customCursorArrows = this.customCursor.querySelector('.arrows')
        // this.customCursorTextDrag = this.customCursor.querySelector('.text-drag')
        // this.customCursorTextPress = this.customCursor.querySelector('.text-press')

        this.vediTutti = this.container.querySelector('.vedi-tutti')

        //Tutorial elements
        this.tutorial = this.container.querySelector('.tutorial')
        this.handWrapper = this.tutorial.querySelector('.hand__wrapper')
        this.handIcon = this.handWrapper.querySelector('.icona')
        this.bottles = this.tutorial.querySelectorAll('.bottiglia .icona')     
        
        this.initEvents()
    }

    initEvents(){
        window.addEventListener("wheel", this.onWheel.bind(this))
        //mobile
        if(isAllMobileDevices){
            window.addEventListener("touchstart", this.onTouchStart.bind(this))
            window.addEventListener("touchmove", this.onTouchMove.bind(this))
            window.addEventListener("touchend", this.onTouchEnd.bind(this))

        }
        //desk
        else{
            window.addEventListener('mousedown', this.onTouchStart.bind(this))
            window.addEventListener('mousemove', this.onTouchMove.bind(this))
            window.addEventListener("mouseup", this.onTouchEnd.bind(this))
        }

        //Previene il drag con il tasto destro
        window.oncontextmenu = this.onTouchEnd.bind(this)

        //resize
        window.addEventListener('resize', () => {
            this.resize()
        })

        awdScroll.stop()
        
        this.setInitialProductPosition().then( () => {
            this.showProducts().then( () => {
                //Tuotrial ancora mai visto
                if (document.cookie.indexOf('drag-to-explore') < 0) {
                    this.showTutorial().then( () => {
                        this.startTutorial().then( () => {
                            this.hideTutorial().then( () => {
                                this.posizionaProdotti().then( () => {
                                    this.showDragToExplore()
                                })            
                            }) 
                        })                    
                    })
                }
                // Il tutorial è stato visto, passo subito all'animazione iniziale dei prodotti
                else{
                    this.posizionaProdotti().then(() => {
                        this.showBadgeVediTutti().then( () => {
                            let delay = 2500
                            if(isAllMobileDevices){
                                delay = 4000
                            }
                            setTimeout( () => {
                                if(!isAllMobileDevices){
                                    this.restringiBadgeVediTutti()
                                }
                            }, delay)
                        })
                    })
                }
            })
        }) 
        // this.ID = window.requestAnimationFrame(() => {
            this.update()
        // })
    }

    showDragToExplore(){
        gsap.to(document.querySelector('.page-shop-wall .drag-to-explore'), {
            duration: 0.5,
            autoAlpha: 1
        })
    }

    hideTutorial(){
        return new Promise( resolve => {
            gsap.to(this.tutorial, {
                duration: 1,
                autoAlpha: 0,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }

    showTutorial(){
        return new Promise( resolve => {
            gsap.to(this.tutorial, {
                duration: 1,
                autoAlpha: 1,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }

    startTutorial(){
        return new Promise( resolve => {
            let duration = 0.9
            gsap.to(this.handIcon, {
                duration,
                scale: 0.6,
                ease:'power1.inOut'
            })
            gsap.to(this.handWrapper, {
                duration,
                delay: 0.5,
                x: '-='+40,
                ease:'power1.inOut'
            })
            gsap.to(this.handWrapper, {
                duration,
                y: '-='+40,
                delay: 1.5,
                ease:'power1.inOut'
            })
            gsap.to(this.handWrapper, {
                duration,
                delay: 2.5,
                x: '+='+80,
                ease:'power1.inOut'
            })
            gsap.to(this.handWrapper, {
                duration,
                y: '+='+80,
                delay: 3.5,
                ease:'power1.inOut'
            })
            gsap.to(this.handWrapper, {
                duration,
                delay: 4.5,
                x: '-='+40,
                y: '-='+40,
                ease:'power1.inOut'
            })
            gsap.to(this.handIcon, {
                duration,
                delay: 5.5,
                scale:1,
                ease:'power1.inOut'
            })
            this.bottles.forEach(bottle => {
                gsap.to(bottle, {
                    duration,
                    scale: 0.8,
                    ease:'power2.inOut'
                })
                gsap.to(bottle, {
                    duration,
                    delay: 0.5+0.15,
                    x: '-='+40,
                    ease:'power2.inOut'
                })
                gsap.to(bottle, {
                    duration,
                    delay: 1.5+0.15,
                    y: '-='+40,
                    ease:'power2.inOut'
                })
                gsap.to(bottle, {
                    duration,
                    delay: 2.5+0.15,
                    x: '+='+80,
                    ease:'power2.inOut'
                })
                gsap.to(bottle, {
                    duration,
                    delay: 3.5+0.15,
                    y: '+='+80,
                    ease:'power2.inOut'
                })
                gsap.to(bottle, {
                    duration,
                    delay: 4.5+0.15,
                    x: '-='+40,
                    y: '-='+40,
                    ease:'power2.inOut'
                })
                gsap.to(bottle, {
                    duration,
                    delay: 5.5+0.15,
                    scale: 1,
                    ease:'power2.inOut',
                    onComplete: () => {
                        resolve()
                    }
                })
            })            
        })
    }


    preventClick(){
        this.products.forEach(product => {
            let a = product.querySelector('a')
            a.addEventListener('click', e => {
                e.preventDefault()
            })
        })
    }

    setInitialProductPosition(){
        return new Promise( resolve => {
            this.calcWholeWidthAndWHeight()
            this.products.forEach((product, i) => {
                const dataRow = product.getAttribute('data-row')
                const dataCol = product.getAttribute('data-col')
                gsap.set(product,{
                    x: (dataCol*this.productRect.width) - this.horizontal.offset,
                    y: dataRow*this.productRect.height,
                    onComplete: () => {
                        if(i === this.products.length-1){
                            resolve()
                        }
                    }
                })
            })
        })
    }

    calcWholeWidthAndWHeight(){
        this.productRect = this.products[0].getBoundingClientRect() 
        this.horizontalElements = this.products[0].getAttribute('data-horizontal-elements')
        this.verticalElements = this.products[0].getAttribute('data-vertical-elements')
        this.wholeWidth = this.productRect.width * this.horizontalElements
        this.wholeHeight = this.productRect.height * this.verticalElements

    }

    showProducts(){
        return new Promise( resolve => {        
            let delay 
            if(document.querySelector('body').classList.contains('not-direct-link')){
                delay = 2
            }
            else{
                delay = 0
            }
            this.products.forEach((product, i) => {
                gsap.to(product.querySelector('.product__outer'),{
                    duration: 1,
                    opacity: 1,
                    delay: delay,
                    onComplete: () => {
                        if(i === this.products.length-1){
                            resolve()
                        }
                    }
                })
            })
        })
    }

    posizionaProdotti(){
        return new Promise( resolve => {
            this.products.forEach((product, i) => {
                product.classList.add('initialized-x')
                product.classList.add('initialized-y')
                setTimeout( () => {
                    gsap.to(product.querySelectorAll('.title__wrapper'),{
                        duration: 1.2,
                        y:0,
                        ease: 'power2.out',
                        onComplete: () => {
                            resolve()
                        }
                    })
                    this.wallDisabled = false
                },1200)
            })
        })
    }

    onWheel(e){
        if(this.wallDisabled) return
        clearTimeout(this.timeout)
        // this.detectDirectionOnWheel(e)
        this.resetAllDirections(1000) 
        this.horizontal.target += e.deltaX * this.speed;
        this.vertical.target += e.deltaY * this.speed;
    }

    onTouchStart(e){
        if(this.wallDisabled) return
        this.isDown = true
        clearTimeout(this.timeout)
        gsap.killTweensOf(this.horizontal.target)
        gsap.killTweensOf(this.vertical.target)
        //update utils body class
        document.querySelector('body').classList.add('is-mouse-down')
        //mouse cursor
        // this.customCursor.classList.remove('discover-element')
        // gsap.to(this.customCursorContainer, {
        //     scale: 0.8,
        //     duration: 0.3
        // })
        // gsap.to(this.customCursorArrows, {
        //     opacity: 1,
        //     duration: 0.3
        // })
        // gsap.to(this.customCursorTextDrag, {
        //     opacity: 1,
        //     duration: 0.3,
        //     ease: 'power1.in'
        // })
        // gsap.to(this.customCursorTextPress, {
        //     opacity: 0,
        //     duration: 0.3,
        //     ease: 'power1.out'
        // })
        //scale image down on touch start
        this.products.forEach((product, i) => {
            product.classList.add('is-mouse-down')
            gsap.to(product.querySelector('img'),{
                scale: 0.9,
                duration: 0.4,
                ease: 'power3.in'
            })
        })        
        //x
        this.horizontal.start = e.touches ? e.touches[0].clientX : e.clientX
        this.horizontal.position = this.horizontal.current
        this.horizontal.distance = 0
        //y
        this.vertical.start = e.touches ? e.touches[0].clientY : e.clientY
        this.vertical.position = this.vertical.current
        this.vertical.distance = 0
    }   

    onTouchMove(e){
        if(this.wallDisabled) return
        if(!this.isDown) return
        //Gestione del tasto "tutorial" per il drag&drop
        setCookie('drag-to-explore')
        // this.hideDragToExplore().then( () => {
            this.showBadgeVediTutti().then(() => {
                let delay = 2500
                if(isAllMobileDevices){
                    delay = 4000
                }
                setTimeout( () => {
                    if(!isAllMobileDevices){
                        this.restringiBadgeVediTutti()
                    }
                }, delay) 
            })
           
        // })
        //update utils body class
        document.querySelector('body').classList.add('is-mouse-moving')
        //stop text selection on drag
        e.preventDefault()
        // this.detectDirectionOnMove()
        //x
        const currentX = e.touches ? e.touches[0].clientX : e.clientX
        this.horizontal.distance = currentX - this.horizontal.start
        this.horizontal.target = this.horizontal.position + this.horizontal.distance * this.power
        //y
        const currentY = e.touches ? e.touches[0].clientY : e.clientY
        this.vertical.distance = currentY - this.vertical.start
        this.vertical.target = this.vertical.position + this.vertical.distance * this.power
    }

    onTouchEnd(e){
        this.isDown = false 

        //update utils body class
        document.querySelector('body').classList.remove('is-mouse-moving')
        document.querySelector('body').classList.remove('is-mouse-down')
        //mouse cursor
        // gsap.to(this.customCursorContainer, {
        //     scale: 1,
        //     duration: 0.3
        // })
        // gsap.to(this.customCursorArrows, {
        //     opacity: 0,
        //     duration: 0.3
        // })
        // gsap.to(this.customCursorTextDrag, {
        //     opacity: 0,
        //     duration: 0.3,
        //     ease: 'power1.out'
        // })
        // gsap.to(this.customCursorTextPress, {
        //     opacity: 1,
        //     duration: 0.3,
        //     ease: 'power1.in'
        // })
        //reset scale image on touch end
        this.products.forEach((product, i) => {
            product.classList.remove('is-mouse-down')
            gsap.to(product.querySelector('img'),{
                scale: 1,
                duration: 0.4
            })
        })               
        //intenzione click
        if(Math.abs(this.horizontal.distance) < 10 && Math.abs(this.vertical.distance) < 10){
            clearTimeout(this.timeout)
            if(e.target.closest('.product') !== null){
                this.handleClick(e.target.closest('.product'))            
            }            
        }
        // intenzione drag           
        else{
            // this.resetAllDirections()             
        }
    }

    resetAllDirections(delay = 50){
        this.timeout = setTimeout( () => {
            this.resetHorizontalPosition()
            this.resetVerticalPosition()
        }, delay)
    }

    resetHorizontalPosition(){
        let targetAfterReset
        if(this.horizontal.target%this.productRect.width < 0){
            if(Math.abs(this.horizontal.target%this.productRect.width) <= this.productRect.width/2){
                targetAfterReset = this.horizontal.target%this.productRect.width         
            }
            else{
                targetAfterReset = this.productRect.width - (Math.abs(this.horizontal.target%this.productRect.width))
            }
        }
        else{
            if(this.horizontal.target%this.productRect.width <= this.productRect.width/2){
                targetAfterReset = this.horizontal.target%this.productRect.width
            }
            else{
                targetAfterReset = this.horizontal.target%this.productRect.width - this.productRect.width
            }
        }
        gsap.to(this.horizontal,{
            duration: 0.5,
            target: '-='+targetAfterReset,
            ease: 'power1.inOut'
        })  
    }

    resetVerticalPosition(){
        let targetAfterReset
        if(this.vertical.target%this.productRect.height < 0){
            if(Math.abs(this.vertical.target%this.productRect.height) <= this.productRect.height/2){
                targetAfterReset =this.vertical.target%this.productRect.height            
            }
            else{
                targetAfterReset = this.productRect.height - (Math.abs(this.vertical.target%this.productRect.height))            
            }
        }
        else{
            if(Math.abs(this.vertical.target%this.productRect.height) <= this.productRect.height/2){
                targetAfterReset = Math.abs(this.vertical.target%this.productRect.height)            
            }
            else{
                targetAfterReset = this.vertical.target%this.productRect.height - this.productRect.height            
            }
        }
        gsap.to(this.vertical,{
            duration: 0.5,
            target: '-='+targetAfterReset,
            ease: 'power1.inOut'
        }) 
    }

    detectDirectionOnWheel(e){
        //detect horizontal direction
        if(e.deltaX < 0){
            this.horizontal.direction = 'left'
        }
        else{
            this.horizontal.direction = 'right'
        }
        //detect vertical direction
        if(e.deltaY < 0){
            this.vertical.direction = 'up'
        }
        else{
            this.vertical.direction = 'down'
        }
    }

    detectDirectionOnMove(){
        //detect horizontal direction
        if(this.horizontal.target - this.horizontal.current < 0){
            this.horizontal.direction = 'left'
        }
        else{
            this.horizontal.direction = 'right'
        }
        //detect vertical direction
        if(this.vertical.target - this.vertical.current < 0){
            this.vertical.direction = 'up'
        }
        else{
            this.vertical.direction = 'down'
        }
    }

    handleClick(product){
        if(document.querySelector('.page-shop--normale') !== null){
            return
        }
        this.centerProduct(product).then( () => {
            // console.log(product)
            // if(product.classList.contains('current')){               
                this.startPageTransition(product)
            // }
        })
    }

    centerProduct(product){
        return  new Promise( resolve => {
            // console.log(product.classList)
            // console.log(typeof(product.classList))
            let productClasses = []
            product.classList.forEach( _class => {
                productClasses.push(_class)
            })
            // console.log(product.classList.includes("current"))
            let productRect = product.getBoundingClientRect()
            let productX = productRect.x
            let productY = productRect.y
            // console.log(productX)
            // const horizontalTargetAfterClick = this.horizontal.target - (productX-this.productRect.width)
            // const horizontalTargetAfterClick = this.horizontal.target - productX + this.productRect.width
            // const horizontalTargetAfterClick = this.horizontal.target - productX + this.productRect.width/2
            // const horizontalTargetAfterClick = this.horizontal.target - productX + this.productRect.width*1.5
            const horizontalTargetAfterClick = this.horizontal.target - productX + (winsize.width/2 - this.productRect.width/2)
            const verticalTargetAfterClick = this.vertical.target - (productY-(this.productRect.height*0.5))
            // if(productX - productX-this.productRect.width)
            let duration = 0.5
            let delay = 550
            //se il prodotto cliccato si trova quasi al centro, velocizzo l'animazione
            if(Math.abs(productX - this.productRect.width) < 100){
                duration = 0.2
                delay= 250
            }
            // console.log(productRect)
            gsap.to(this.horizontal,{
                duration,
                target: horizontalTargetAfterClick,
                ease: 'power1.inOut'
            })
            gsap.to(this.vertical,{
                duration,
                target: verticalTargetAfterClick,
                ease: 'power1.inOut'
            })
            //Rifinisco il centramento che non è sempre preciso al primo colpo
            setTimeout( () => {
                productRect = product.getBoundingClientRect()
                productX = productRect.x
                productY = productRect.y
                let interval = setInterval( () => {
                    productX += (this.productRect.width - productX)*0.1
                    productY += (this.productRect.height/2 - productY)*0.1
                    product.style.transform = `translate(${productX}px, ${productY}px)`
                },16)
                setTimeout( () => {
                    clearInterval(interval)
                },400)
                if(productClasses.includes('current')){
                    resolve()
                }
            },delay)
    

        })      
    }

    startPageTransition(product){
        if(!isAllMobileDevices){
            // this.hideDragToExplore()
            this.hideBadgeVediTutti()
            this.hideOthersProduct(product)
            this.hideTitle(product)
        }
        this.goToProductPage(product)
    }

    hideDragToExplore(){
        return new Promise(resolve => {
            gsap.to(document.querySelector('.page-shop-wall .drag-to-explore'), {
                duration: 0.5,
                autoAlpha: 0,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }
    showBadgeVediTutti(){
        // riseAndFadeIn(this.vediTutti)
        return new Promise( resolve => {
            gsap.to(this.vediTutti, {
                duration: 0.8,
                autoAlpha: 1,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }
    restringiBadgeVediTutti(){
        this.vediTutti.classList.remove('active')
    }
    hideBadgeVediTutti(){
        gsap.to(this.vediTutti, {
            duration: 0.4,
            autoAlpha: 0
        })
    }

    hideTitle(product){
        let productTitle = product.querySelectorAll('.product__title')
        gsap.to(productTitle, {
            duration:0.6,
            autoAlpha:0,
            delay: 0.2
        })

    }

    hideOthersProduct(product){
        this.products.forEach( p => {
            if(!product.isSameNode(p)){
                p.classList.add('disabled')
                gsap.to(p, {
                    duration: 0.6,
                    autoAlpha: 0
                })
            }
        })        
    }
    goToProductPage(product){
        let delay = 0.1
        let productLink = product.getAttribute('data-product-link')
        if(!isAllMobileDevices){
            product.classList.add('active')
            document.querySelector('body').classList.add('destination-page-product')
            delay = 1000
        }
        // //change page
        setTimeout( () => {
            barba.go(productLink)
        }, delay)

    }

    resize(){

        this.sizes.width = window.innerWidth
        this.sizes.height = window.innerHeight
        this.products.forEach(product => {
            product.style.width = this.sizes.width/3
            product.style.height = this.sizes.height/2
        })
        this.calcWholeWidthAndWHeight()
        this.resetAllDirections()
    }

    update(){
        if(document.querySelector('.page-shop-wall') === null){
            return
        }
        // console.log(this.wholeWidth)
        //x
        this.horizontal.velocity = this.horizontal.target - this.horizontal.current
        this.horizontal.current += (this.horizontal.target - this.horizontal.current)*this.easing
        //y
        this.vertical.velocity = this.vertical.target - this.vertical.current
        this.vertical.current += (this.vertical.target - this.vertical.current)*this.easing
        
        let alwaysPositiveHorizontal = (1+Math.round(Math.abs(this.horizontal.current)/this.wholeWidth))*this.wholeWidth
        let alwaysPositiveVertical = (1+Math.round(Math.abs(this.vertical.current)/this.wholeHeight))*this.wholeHeight
        this.products.forEach( (product, i) => {
            let productRect = product.getBoundingClientRect()
            let productX = productRect.x
            let productY = productRect.y
            const dataRow = product.getAttribute('data-row')
            const dataCol = product.getAttribute('data-col')
            // const translateX = (dataCol*this.productRect.width+this.horizontal.current + alwaysPositiveHorizontal)%this.wholeWidth - this.productRect.width
            if(dataRow % 2 === 1){
            //     if(isAllMobileDevices){
            //         this.horizontal.mobileShift = 0
                this.horizontal.offset = this.productRect.width/2
            //     }
            }
            else{
            //     this.horizontal.mobileShift = this.sizes.width/2
                this.horizontal.offset = 0

            }
            // const translateX = (dataCol*this.productRect.width-this.horizontal.offset+this.horizontal.current + alwaysPositiveHorizontal)%this.wholeWidth - this.productRect.width
            const translateX = (dataCol*this.productRect.width+this.horizontal.current + alwaysPositiveHorizontal)%this.wholeWidth - this.productRect.width - this.horizontal.offset
            const translateY = (dataRow*this.productRect.height+this.vertical.current + alwaysPositiveVertical)%this.wholeHeight - this.productRect.height*1.5
            //move element
            product.style.transform = `translate(${translateX}px, ${translateY}px)`
            //text parallax
            product.querySelector('.product__image .image').style.transform = `translate(${-this.horizontal.velocity*0.2}px, ${-this.vertical.velocity*0.2}px)`
            // if(Math.abs(productX - this.productRect.width   ) < 100 && Math.abs(productY - this.productRect.width/2) < 200){
            if(Math.abs(productX - (winsize.width/2 - this.productRect.width/2)   ) < winsize.width*0.04 && Math.abs(productY - this.productRect.width/2) < 200){
                if(!this.wallDisabled){
                    product.classList.add('current')
                    // product.classList.add('custom-cursor-element')
                    product.setAttribute('data-custom-cursor', 'discover')
                }
            }
            else{
                product.classList.remove('current')
                // product.classList.remove('custom-cursor-element')
                product.setAttribute('data-custom-cursor', '')
            }
        })
        this.ID = window.requestAnimationFrame(() => {
            this.update()
        })
    }

    dispose(){
        //mobile
        window.removeEventListener("wheel", this.onWheel.bind(this))
        window.removeEventListener("touchstart", this.onTouchStart.bind(this))
        window.removeEventListener("touchmove", this.onTouchMove.bind(this))
        window.removeEventListener("touchend", this.onTouchEnd.bind(this))
        //desk

        window.removeEventListener('mousedown', this.onTouchStart.bind(this))
        window.removeEventListener('mousemove', this.onTouchMove.bind(this))
        window.removeEventListener('mouseup', this.onTouchEnd.bind(this))        
        
        
    }
}

export {InfiniteWall}